import React from 'react'

import './PlayerBuffering.css'

export default class PlayerBuffering extends React.PureComponent {

	render() {
		return (
			<div  className="player__buffering">
				<svg viewBox="25 25 50 50" >
						<g className="circular" id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="button/play/spinner-shape" strokeWidth="1.5" stroke="#FFFFFF">
										<circle  className="path" cx="50" cy="50" r="23.5"></circle>
								</g>
						</g>
				</svg>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/player/controls/buffering/PlayerBuffering.jsx